export default function PHP_private() {
  return (
    <div>
      <h1>PHP_private</h1>
    </div>
  );
}
